import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrls: ['./upload-image.component.scss']
})
export class UploadImageComponent implements OnInit {
  fileName: string;
  uploadImageForm: FormGroup;
  blob: Blob;
  file: File;
  fileSize: any;
  size: number;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  constructor(
    private fb: FormBuilder,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<UploadImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.uploadImageForm = this.fb.group({
      photo: ['', Validators.required],
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }


  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.fileName = event.target.files[0].name;
    this.size = event.target.files[0].size / 1024;
    this.fileSize = Math.round(this.size / 1024) + '' + ' KB';
    if (this.fileSize > 1e+7) {
      const snackBarRef = this.snackbar.open('image size is more than 10 MB', null, { duration: 2000 });
    }
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    const arr = event.base64.split(',');
    this.uploadImageForm.get('photo').patchValue(arr[1]);
  }

  onSubmit() {
    if (this.uploadImageForm.valid) {
      if (this.fileSize > 1e+7) {
        const snackBarRef = this.snackbar.open('image size is more than 10 MB', null, { duration: 2000 });
      }
      else {
        this.dialogRef.close({
          result: true,
          fileName: this.fileName,
          photoPath: this.uploadImageForm.get('photo').value,
          Image: this.croppedImage
        });
      }
    }
    else {
      this.snackbar.open('Please select an image', null, { duration: 2000 });
    }
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
